import { render, staticRenderFns } from "./page-foot.vue?vue&type=template&id=21852fe5&scoped=true"
import script from "./page-foot.vue?vue&type=script&lang=js"
export * from "./page-foot.vue?vue&type=script&lang=js"
import style0 from "./page-foot.vue?vue&type=style&index=0&id=21852fe5&prod&lang=less&scoped=true"
import style1 from "./style/h5-page-foot.less?vue&type=style&index=1&id=21852fe5&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21852fe5",
  null
  
)

export default component.exports